// ============================================================
// Icon registry
// ------------------------------------------------------------
// Every icon used in the onboarding flow is referenced from a
// single place. Icons are imported from the assets directory.
//
// All icons are consumed as plain <img> tags (no inline SVG is
// generated by the app).
// ============================================================

import editIcon from "../../assets/images/icon/edit.svg"
import deleteIcon from "../../assets/images/icon/trash.svg"
import calendarIcon from "../../assets/images/icon/calendar.svg"
import calendarOutlineIcon from "../../assets/images/icon/calendar-icon.svg"
import checkIcon from "../../assets/images/icon/check.svg"
import tickWhiteIcon from "../../assets/images/icon/tick-white.svg"
import plusIcon from "../../assets/images/icon/add.svg"
import arrowRightIcon from "../../assets/images/icon/arrow-right.svg"
import arrowLeftIcon from "../../assets/images/icon/arrow-left.svg"
import informationIcon from "../../assets/images/icon/information-i.svg"
import chevronDownIcon from "../../assets/images/icon/arrow-down.svg"
import chevronDownBlueIcon from "../../assets/images/icon/chevron-down-blue.svg"
import listCheckIcon from "../../assets/images/icon/list-check.svg"

export const ICONS = {
  edit: editIcon,
  delete: deleteIcon,
  calendar: calendarIcon,
  calendarOutline: calendarOutlineIcon,
  check: checkIcon,
  tickWhite: tickWhiteIcon,
  plus: plusIcon,
  arrowRight: arrowRightIcon,
  arrowLeft: arrowLeftIcon,
  information: informationIcon,
  chevronDown: chevronDownIcon,
  chevronDownBlue: chevronDownBlueIcon,
  listCheck: listCheckIcon,
}
